<template>
    <div class="user-info">
        <MessagesWidget v-if="projectId && !isMainDomain"/>
        <DropdownUser/>
    </div>
</template>

<script>
import {mapState} from "vuex";
import MessagesWidget from "@/components/navbar/components/MessagesWidget.vue";
import DropdownUser from "@/components/navbar/components/DropdownUser.vue";

export default {
    name: 'UserInfo',
    components: {DropdownUser, MessagesWidget},
    computed: {
        ...mapState({
            isMainDomain: state => state.navbar.isMainDomain,
            projectId: state => state.navbar.projectId,
        }),
    },
}
</script>
